import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Chat.css";
import { env } from "../../environment";
import { useNavigate } from "react-router-dom";
import { fetchModelDetails, postFeedback } from "../../store/apiActions";
import { useDispatch, useSelector } from "react-redux";
import outputArrow from "../../assets/images/outputArrow.png";
import like from "../../assets/images/like.svg";
import dislike from "../../assets/images/dislike.svg";
import likeSelected from "../../assets/images/likeSelected.svg";
import dislikeSelected from "../../assets/images/dislikeSelected.svg";
import copyInactive from "../../assets/images/copy.svg";
import copyActive from "../../assets/images/copy-active.svg";
import editIcon from "../../assets/images/edit.svg";
import closeIcon from "../../assets/images/closeIcon.png";
import { marked } from "marked";
import fileDoc from "../../assets/images/mainCard1.svg";
import help from "../../assets/images/mainCard2.svg";
import compareDoc from "../../assets/images/mainCard3.svg";
import Sidebar from "../../components/Sidebar/Sidebar";
import Tooltip from "../../components/Title/Title";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import sidebarIcon1 from "../../assets/images/Black.svg";
import sidebarIcon2 from "../../assets/images/Black-1.svg";
import sidebarIcon4 from "../../assets/images/Black-2.svg";
import sidebarIcon1Active from "../../assets/images/White.svg";
import sidebarIcon2Active from "../../assets/images/White-1.svg";
import sidebarIcon4Active from "../../assets/images/White-2.svg";
import botIcon from "../../assets/images/Menu Icon Background.svg";
import { MathJaxContext } from "better-react-mathjax";
import DOMPurify from "dompurify";
import sanitizeInput from "../../contexts/PreventSpecialChar";
import { encrypted } from "../../utils/Utility";
import "font-awesome/css/font-awesome.min.css";
// import JSON5 from "json5";
import Header from "../../components/Header/Header";
import insertArrow from "../../assets/images/arrow_insert.svg";
import Modal from "../../components/Modal";
// import uploadIcon from '../../assets/images/fileUpload.svg';
import speakerIcon from '../../assets/images/iconoir_sound-low.svg';
import speakerFilledIcon from '../../assets/images/iconoir_sound-low 1.svg';
// import loadingImage from '../../assets/images/loading.png';
// import {Buffer} from 'buffer';

function preserveMathBlocks(text) {
  const mathBlocks = [];
  const replaced = text?.replace(
    /(\$\$.*?\$\$|\\\[.*?\\\]|\\\(.*?\\\))/gs,
    (match) => {
      const placeholder = `@@MATH${mathBlocks.length}@@`;
      mathBlocks.push(match);
      return placeholder;
    }
  );
  return { replaced, mathBlocks };
}

function restoreMathBlocks(html, mathBlocks) {
  return mathBlocks.reduce(
    (acc, math, index) => acc.replace(`@@MATH${index}@@`, math),
    html
  );
}

function Chat() {
  const roles = [
    {
      id: 1,
      name: "Wordsmith",
      text: "Hi, I am Wordsmith, your intelligent writing companion designed to elevate your content creation. Whether you are drafting reports, presentations, or composing professional emails, I am here to help you communicate with clarity, precision, and style.",
      icon: sidebarIcon1,
      title: "Professional writing assistant",
      activeIcon: sidebarIcon1Active,
    },
    {
      id: 2,
      name: "Agronomica",
      text: "Hi, I am Agronomica, your expert agricultural companion dedicated to answering questions about crop science, soil management, sustainable farming, and agricultural technologies. From soil health to crop optimisation, I am here to provide insights and support for you.",
      icon: sidebarIcon2,
      title: "Sustainable farming guide",
      activeIcon: sidebarIcon2Active,
    },
    {
      id: 3,
      name: "Regulatrix",
      text: "Hi, I am Regulatrix, your comprehensive regulatory companion for the agrochemical industry, designed to navigate the complex landscape of agricultural regulations and compliance standards. I provide expert guidance on regulatory requirements, safety protocols, environmental regulations, and compliance strategies to support your agricultural business legal and ethical operations.",
      icon: sidebarIcon4,
      title: "Agrochemical compliance advisor",
      activeIcon: sidebarIcon4Active,
    },
  ];
  const [activeTab, setActiveTab] = useState(null);
  const [message, setMessage] = useState("");
  const [suggestionAPICall, setSuggestionAPICall] = useState(false);
  const [cardClicked, setCardClicked] = useState(false);
  const chatEndRef = useRef(null);
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState("GPT-4o");
  const [model, setModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [showNewChat, setShowNewChat] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [converstation, setConverstation] = useState([]);
  const [uiConversation, setUIConversation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTypingFeedback, setIsTypingFeedback] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState({});
  const [feedbackInput, setFeedbackInput] = useState("");
  const [feedbackData, setFeedbackData] = useState({});
  const [currentFeedbackIndex, setCurrentFeedbackIndex] = useState(null);
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const feedbackInputRef = useRef(null);
  const feedbackContainerRef = useRef(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const [submittingFeedback, setSubmittingFeedback] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [selectedRoleDetails, setSelectedRoleDetailes] = useState([]);
  const [copied, setCopied] = useState(false);
  const [activeMessageId, setActiveMessageId] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [feedbackButtonsDisabled, setFeedbackButtonsDisabled] = useState(() => {
    const savedDisabled = localStorage.getItem("feedbackButtonsDisabled");
    return savedDisabled && savedDisabled !== "undefined"
      ? JSON.parse(savedDisabled)
      : {};
  });
  const [editingId, setEditingId] = useState(null);
  const [editedText, setEditedText] = useState("");
  const textareaRef = useRef(null);
  const streamReaderRef = useRef(null);
  const lineHeight = 24; // Set your line height here
  const minLines = 1;
  const maxLines = 7;
  const assistantRefs = useRef([]);
  const { subscribe,emit } = useEventEmitter();
  const modelResponse = useSelector(
    (state) => state?.api?.modelDetails?.data || []
  );
  const feedbackResponse = useSelector(
    (state) => state?.api?.feedbackDetails?.data || []
  );
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const storedData = localStorage.getItem("LoggedInDetails");

  const getUsername = () => {
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.username;
    }
    return null;
  };
  const getUserUGDN = () => {
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.ugdn_id;
    }
    return null;
  };
  useEffect(() => {
  const unsubscribe = subscribe("clearChat", () => {
    clearChatData();
    setActiveTab(null);
  });
  return () => unsubscribe();
  }, []);
  const getFullname = () => {
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.full_name;
    }
    return null;
  };
  const username = getUsername();
  const fullname = getFullname();
  const userUGDN = getUserUGDN();
  const token = localStorage.getItem("token");
  
  const clearChatData = () => {
    setConverstation([]);
    setUIConversation([]);
    setSelectedFeedback({});
    setFeedbackButtonsDisabled({});
    const newSessionId = crypto?.randomUUID();
    setSessionId(newSessionId);
    localStorage.setItem("sessionId", newSessionId);
    setShowChatModal(false);
    setShowNewChat(false);
    localStorage.removeItem("logout");
  };

  const addMessagesFunction = (role_name, text) => {
    setTimeout(() => {
      const botMessage = { sender: "bot", text: text, message_id: null };
      setSelectedRoleDetailes(botMessage);
    }, 50);
  };

  const handleCopyClick = async (index) => {
    const el = assistantRefs.current[index];
    if (!el) return;

    const visibleText = el.innerText || el.textContent; // Get rendered visible content

    try {
      await navigator.clipboard.writeText(visibleText.trim());
      setCopied(true);
      toast.success("Copied to clipboard!", { autoClose: 1000 });
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (err) { 
      toast.error("Failed to copy.");
    }
  };

  const [isUpdateThread, setIsUpdateThread] = useState(false);
  const generateCustomId = () => {
    const shortUuid = crypto.randomUUID().slice(0, 3); // 'abc'
    const timestamp = Date.now(); // 1719231123123
    return `${shortUuid}_${timestamp}`; // abc_1719231123123
  };

  const [loading, setLoading]=useState(false)
  const handleSendMessage = async ({
    isEdit = false,
    editedConvo = [],
    editedMessage = null,
    messageID = null,
  } = {}) => {
    textareaRef.current.style.height = `${lineHeight * minLines}px`;
    const userMessageId = generateCustomId();
    const userMessage = isEdit
  ? { role: "user", content: editedMessage?.content, id: messageID }
  : { role: "user", content: message, id: userMessageId };
    const placeholderBotMessage = {
      role: "assistant",
      content: "Loading...",
      isPlaceholder: true,
      id: isEdit?messageID:userMessageId,
      feedback:'',
    };
  
    const updatedUI = isEdit
      ? [...editedConvo, userMessage, placeholderBotMessage]
      : [...converstation, userMessage, placeholderBotMessage];
    setLoading(true)
    setUIConversation(updatedUI);
    setSuggestions([]);
    if (!isEdit) setMessage("");
    setIsLoading(true);
    const messagesForAPI = isEdit
      ? [...editedConvo, userMessage]
      : [...converstation, userMessage];
 
    try {
      const response = await fetch(`${env.baseURL}/chat/completions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          encryptedBody: encrypted.encrypt(
            JSON.stringify({
              ugdn_id: username || '',
              user_id: username,
              chat_id: `UID${sessionId.substring(0, 3)}`,
              message_id: isEdit?messageID:userMessageId,
              session_id: sessionId,
              tool_ids: [],
              files: [],
              features: {
                additionalProp1: "",
                additionalProp2: "",
                additionalProp3: "",
              },
              variables: {
                additionalProp1: "",
                additionalProp2: "",
                additionalProp3: "",
              },
              model: selectedModel,
              messages: messagesForAPI,
              isEdit:isEdit? "True" : "False",
              editMessageId:isEdit?messageID:'',
              stream: true,
              query: userMessage.content,
              role_name: roles[activeTab - 1]?.name || "",
              role_flag: roles[activeTab - 1]?.name?.length ? "True" : "False",
              params: {},
            })
          ),
        }),
      });
  
      if (response.status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.clear();
        setTimeout(() => {
          navigate("/sign-in");
        }, 1500);
        return;
      }
  
      if (!response.ok || !response.body) throw new Error("Streaming failed");
  
      const reader = response.body.getReader();
      streamReaderRef.current = reader;
      const decoder = new TextDecoder("utf-8");
  
      let streamedText = "";
      let metadata = null;
      let jsonPart = "";
      let accumulatedEncryptedData = "";
      let isMetaEnd = false;
      
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
      
        const chunkEncrypted = decoder.decode(value, { stream: true });
        const lines = chunkEncrypted.split("\n").filter(Boolean);
      
        for (const line of lines) {
          if (line.startsWith("data:")) {
            const encryptedPart = line.slice(5).trim();
            accumulatedEncryptedData += encryptedPart;
          } else if (line.startsWith("meta_end:")) {
            if (line.slice(9).trim() === "true") {
              isMetaEnd = true;
            }
          } else {
            try {
              const decryptedLine = await encrypted.decrypt(line);
              streamedText += decryptedLine;
      
              const updatedStreamMessage = {
                ...placeholderBotMessage,
                content: streamedText,
              };
      
              setUIConversation([...messagesForAPI, updatedStreamMessage]);
            } catch (err) {
              // Skip invalid decrypt lines
            }
          }
        }
      
        // When all metadata received
        if (isMetaEnd && accumulatedEncryptedData) {
          try {
            const decrypted = await encrypted.decrypt(accumulatedEncryptedData);
            const parsed = JSON.parse(decrypted);
            metadata = parsed;      
            setIsUpdateThread(parsed?.title_flag);
            if (parsed?.title_flag === true) emit("refreshThreads");
            if (parsed?.thread_move_flag === true) emit("refreshThreads");
      
            setSuggestions(parsed?.suggestive_prompts);
            setActiveMessageId(parsed?.message_id);
            if (parsed.message_id && !metadata?.message_id) {
              metadata = { ...metadata, message_id: parsed?.message_id };
            }
      
            if (parsed.response_text) {
              streamedText += parsed.response_text;
      
              const updatedStreamMessage = {
                ...placeholderBotMessage,
                content: streamedText,
                id: isEdit?messageID:userMessageId,
              };
              setUIConversation([...messagesForAPI, updatedStreamMessage]);
            }
      
            // Reset after processing metadata
            accumulatedEncryptedData = "";
            isMetaEnd = false;
            setLoading(false);
          } catch (err) {
            setLoading(false);
            console.warn("Failed to decrypt metadata:", err);
          }
        }
      }
      
      const finalBotMessage = {
        role: "assistant",
        content: streamedText || metadata?.response_text || "",
        id: isEdit?messageID:userMessageId,
        image_data: metadata?.image_data,
        feedback:'',
      };
  
      const finalConvo = [...messagesForAPI, finalBotMessage];
      setConverstation(finalConvo);
      setUIConversation(finalConvo);
      setLoading(false);
    } catch (error) {
      console.error("Chat error:", error);
      const errorMessage = {
        role: "assistant",
        content: "Sorry, I'm having trouble understanding that.",
        feedback:'',
      };
      const updatedConvo = [...messagesForAPI, errorMessage];
      setConverstation(updatedConvo);
      setUIConversation(updatedConvo);
    }
    streamReaderRef.current = null;
    setIsLoading(false);
    setLoading(false);
  };

  
   const stopStreaming = () => {
    if (streamReaderRef.current) {
      streamReaderRef?.current?.cancel();
      streamReaderRef.current = null;
      setConverstation([]);
      setUIConversation([]);
    }
  };

  const fetchUserConversation = async (user_id, session_id ) => {
    const token = localStorage.getItem("token");
    setConverstation([]);
    setUIConversation([]);
    setActiveTab(null);
    setSuggestions([]);
    try {
      const response = await fetch(
        `${env.baseURL}/fetch-user-conversation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            encryptedBody: encrypted.encrypt(
              JSON.stringify({ 'user_id': user_id, 'session_id': session_id })
            ),
          }),
        }
      );
      if (!response?.ok) {
        // throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const data = await response?.json();
      let conversionData = JSON.parse(encrypted?.decrypt(data?.encryptedBody))
      const match = roles.find((role) => role.name === conversionData?.role_name);
        if (match) {
          addMessagesFunction(match.name, match.text);
          setActiveTab(match.id);
          stopStreaming();
          // clearChatData();
        }
      setActiveMessageId(conversionData?.data[conversionData?.data?.length-1]?.id||null)
      setSuggestions(conversionData?.suggestive_prompts)
      setUIConversation(conversionData?.data||[]);
      setConverstation(conversionData?.data||[]);
      // return data;
    } catch (error) {
      console.error("Error fetching user conversation:", error);
      throw error;
    }
  };

  function handleSearchSuggestion(text) {
    setMessage(text);
    setSuggestionAPICall(true);
  }

  useEffect(() => {
    if (suggestionAPICall === true) {
      handleSendMessage();
      setSuggestionAPICall(false);
    }
  }, [suggestionAPICall]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = `${lineHeight * minLines}px`;
    }
    // Load selectedFeedback
    const savedSelectedFeedback = JSON.parse(
      localStorage.getItem("selectedFeedback")
    );
    if (savedSelectedFeedback) {
      setSelectedFeedback(savedSelectedFeedback);
    }
  }, []);

  const handleInputChange = (e) => {
    setMessage(e.target.value);
    const textarea = textareaRef.current;

    // Calculate based on content, clamp between 3 and 7 lines
    textarea.style.height = "auto"; // reset first
    const newHeight = Math.max(
      lineHeight * minLines,
      Math.min(textarea.scrollHeight, lineHeight * maxLines)
    );
    textarea.style.height = `${newHeight}px`;
  };

  const handleEditClick = (index, role, id) => {
    if (role === "user") {
      setEditingId(index);
      setEditedText(uiConversation[index].content);
    }
  };

  const handleSave = async (editIndex, editData) => {
    const updatedFeedback = {};
    // Keep only entries with keys < editIndex
    for (const key in selectedFeedback) {
      if (parseInt(key) < editIndex) {
        updatedFeedback[key] = selectedFeedback[key];
      }
    }
    // Update state
    setSelectedFeedback(updatedFeedback);
    // Trim feedbackButtonsDisabled
    const trimmedButtonsDisabled = {};
    for (const key in feedbackButtonsDisabled) {
      if (parseInt(key) < editIndex) {
        trimmedButtonsDisabled[key] = feedbackButtonsDisabled[key];
      }
    }
    setFeedbackButtonsDisabled(trimmedButtonsDisabled);
    // Optional: Persist back to localStorage if needed
    localStorage.setItem(
      "feedbackButtonsDisabled",
      JSON.stringify(trimmedButtonsDisabled)
    );
    setEditingId(null);
    if (!editedText.trim()) return;
    const editingIndex = converstation.findIndex(
      (msg, index) => index === editIndex && msg.role === "user"
    );
    if (editingIndex === -1) {
      return;
    }
    stopStreaming();
    const updatedUserMessage = {
      role: "user",
      content: sanitizeInput(editedText.trim()),
    };
    const trimmedConvo = converstation.slice(0, editingIndex);
    await handleSendMessage({
      isEdit: true,
      editedConvo: trimmedConvo,
      editedMessage: updatedUserMessage,
      messageID: editData?.id,
    });

    setEditedText("");
  };

  useEffect(() => {
    const unsubscribe = subscribe("thread", (data) => {
      setSessionId(data)   
      setShowFeedbackInput(false);
      setCurrentFeedbackIndex(null);
      const localSessionId= localStorage.getItem('sessionId');
      setEditingId(null);
        // if(localSessionId !== data?.session_id){
        fetchUserConversation(username,data);
        stopStreaming();
        // }
    });
    return () => unsubscribe();
  }, [subscribe]);

 useEffect(() => {
  const unsubscribe = subscribe("newChat", (data) => {
    setShowNewChat(true);
  });
  return () => unsubscribe();
}, [subscribe]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        event.preventDefault();
        const textarea = event.target;
        const cursorPosition = textarea.selectionStart;
        const textBefore = message.substring(0, cursorPosition);
        const textAfter = message.substring(cursorPosition);
        const newText = textBefore + "\n" + textAfter;
        setMessage(newText);
        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;
        }, 0);
      } else {
        event.preventDefault();
        const trimmedMessage = message.trim();
        if (trimmedMessage === "") return;
        handleSendMessage();
      }
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("isLogin");
    if (data) {
      toast.success("You are successfully logged in");
      localStorage.removeItem("isLogin");
    }
  }, []);

  useEffect(() => {
    if (cardClicked) {
      handleSendMessage();
      setCardClicked(false);
    }
  }, [cardClicked]);

  const chatContainerRef = useRef(null);
  const [userScrolled, setUserScrolled] = useState(false);

  // Detect if user manually scrolls up
  const handleScroll = () => {
    const el = chatContainerRef.current;
    if (!el) return;

    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 10;
    setUserScrolled(!atBottom); // if not at bottom, user has scrolled
  };

  // Scroll to bottom only if user hasn't scrolled manually
  const scrollToBottom = () => {
    if (!userScrolled) {
      chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Call scrollToBottom when new messages arrive
  useEffect(() => {
    scrollToBottom();
  }, [converstation, uiConversation]);

  // Attach scroll listener once
  useEffect(() => {
    const el = chatContainerRef.current;
    if (!el) return;

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted && window.MathJax?.typesetPromise) {
      window.MathJax.typesetPromise().catch((err) =>
        console.error("MathJax typeset error:", err)
      );
    }
  }, [converstation]);

  const handleModelChange = (eventOrName) => {
    let modelName;

    if (typeof eventOrName === "string") {
      modelName = eventOrName;
    } else if (eventOrName?.target?.value) {
      modelName = eventOrName.target.value;
    }

    if (modelName) {
      setSelectedModel(modelName);
      setIsOpen(false);
    }
  };

  const getSanitizedHTML = (text) => {
    const { replaced, mathBlocks } = preserveMathBlocks(text);
    const htmlMessage = marked(replaced, {
      breaks: true,
    });
    const sanitizedMessage = DOMPurify.sanitize(
      restoreMathBlocks(htmlMessage, mathBlocks),
      {
        ADD_TAGS: ["math", "mi", "mo", "mn", "ms", "mrow"],
        ADD_ATTR: ["xmlns"],
      }
    );
    return sanitizedMessage;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    toast.success("Logout successful!");
    localStorage.clear();
    setShowModal(false);
    navigate("/sign-in");
  };

  const handleContinue = () => {
    setShowChatModal(false);
  };

  const handleNewSessionCancel = () => {
    setShowNewChat(false);
  };

  const handleNewSessionContinue = async() => {
    stopStreaming();
    setActiveTab(null);
    setShowNewChat(false);
    await emit("resetSelectedThread",true);
    clearChatData();
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // useEffect(() => {
  //   dispatch(fetchModelDetails(`${env.baseURL}/models/base`));
  // }, [dispatch]);

  useEffect(() => {
    setModel(modelResponse?.data);
  }, [modelResponse]);

  const handleFeedback = async (index, type, data) => {
    // Add this line after you setSelectedFeedback(...)
    setUIConversation((prev) =>
      prev.map((msg, idx) =>
        idx === index ? { ...msg, feedback: type } : msg
      )
    );

    const oppositeType = type === "like" ? "dislike" : "like";
    // Reset input if type changed
    if (selectedFeedback[index] !== type) {
      setFeedbackInput((prev) => {
        const updated = { ...prev };
        if (updated[index]) delete updated[index];
        return updated;
      });
      setFeedbackInput("");
    }

    // Update feedback data and selection
    setFeedbackData((prev) => ({
      ...prev,
      [index]: { type, comment: "" },
    }));

    setSelectedFeedback((prev) => ({
      ...prev,
      [index]: type,
    }));

    setCurrentFeedbackIndex(index);
    setShowFeedbackInput(type === "dislike");

    // Disable only the selected type and reset the opposite type
    setFeedbackButtonsDisabled((prev) => ({
      ...prev,
      [index]: {
        [type]: true,
        [oppositeType]: false,
      },
    }));

    await handleFeedbackSubmit(type, index, data);

    setTimeout(() => {
      if (
        feedbackInputRef.current &&
        feedbackContainerRef.current.offsetParent !== null
      ) {
        feedbackInputRef.current.focus();
        feedbackContainerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 0);
  };

  const handleFeedbackModalClose = (index) => {
    setShowFeedbackInput(false);
    setCurrentFeedbackIndex(null);
    setFeedbackInput({});
  };

  const handleFeedbackCommentChange = (event) => {
    const updatedComment = event.target.value;
    setFeedbackInput((prevFeedback) => ({
      ...prevFeedback,
      [currentFeedbackIndex]: {
        ...prevFeedback[currentFeedbackIndex],
        comment: updatedComment,
      },
    }));
    setIsTypingFeedback(updatedComment.trim().length > 0);
  };

  const handleKeyPressFeedback = (event, type, index, pair) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent any Enter key behavior
      handleFeedbackModalClose(index);
      handleFeedbackSubmit(type, index, pair);
      if (event.shiftKey) {
        setFeedbackInput((prevFeedback) => ({
          ...prevFeedback,
          [currentFeedbackIndex]: {
            ...prevFeedback[currentFeedbackIndex],
            comment: (prevFeedback[currentFeedbackIndex]?.comment || "") + "\n",
          },
        }));
      }
    }
  };

  const handleFeedbackSubmit = async (type, index, pair) => {
    if (submittingFeedback) {
      return;
    }
    setSubmittingFeedback(true);
  
    try {
      const requestBody = {
        session_id: sessionId,
        message_id: pair?.id,
        feedback: type || "",
        feedback_comment: sanitizeInput(
          feedbackInput[currentFeedbackIndex]?.comment || ""
        ),
        user_id: username,
      };
  
      const response = await fetch(`${env.baseURL}/update-feedback-chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Add auth token if required:
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          encryptedBody: encrypted.encrypt(JSON.stringify(requestBody))
        }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to submit feedback");
      }
  
      // Show success message
      toast.success("Feedback submitted successfully");
      // Clear only the submitted feedback input
      setFeedbackInput((prev) => ({
        ...prev,
        [currentFeedbackIndex]: { comment: "" },
      }));
      setIsTypingFeedback(false);
      setFeedbackData((prevFeedback) => ({
        ...prevFeedback,
        [currentFeedbackIndex]: { type: "", comment: "" },
      }));
    } catch (error) {
      console.error("Feedback submit error:", error);
      toast.error("Failed to submit feedback");
    } finally {
      setSubmittingFeedback(false);
    }
  };
  

  // useEffect(() => {
  //   const newSessionId = crypto.randomUUID();
  //   setSessionId(newSessionId);
  //   localStorage.setItem("sessionId", newSessionId);
  // }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".user-dropdown") &&
        !event.target.closest(".icon-button")
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSettingUserModal = () => {
    setIsUserMenuOpen(false);
  };

  const handleOpenForm = () => {
    window.open(
      "https://forms.office.com/r/i2Wzj1baFs",
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handleFaqNavigation = () => {
    navigate("/user-guide");
  };
  const sidebarProps = isUpdateThread === true ? { isUpdateThread: true } : {};
  const audioRef = useRef(null);
  const [currentAudioId, setCurrentAudioId] = useState(null);
  const handleFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles.length === 0) return;
  
    try {
      // Convert each file to base64 and collect metadata
      const filesData = await Promise.all(
        newFiles.map((file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              resolve({
                name: file.name,
                type: file.type,
                size: file.size,
                content: reader.result.split(",")[1], // strip the data prefix
              });
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        })
      );
  
      // Construct your original metadata with embedded files
      const metadata = {
        user_id: username,
        ugdn_id: username,
        session_id: sessionId,
        message_id:activeMessageId,
        files: filesData, 
      };
      // Encrypt the metadata
      const encryptedBody = encrypted.encrypt(JSON.stringify(metadata));
  
      // Send the encrypted payload as raw JSON
      const response = await fetch(`${env.baseURL}/files/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedBody }),
      });
  
      if (!response.ok) throw new Error("Failed to upload");
  
      const result = await response.json();
    } catch (error) {
      console.error("Upload failed:", error);
    }
  
    // Allow same file to be selected again
    e.target.value = "";
  };


  const fetchAudio = async ({ messageId, sessionId, token, messageText }) => {
    setCurrentAudioId(null);
    try {
      const response = await fetch(`${env.baseURL}/read_out_answer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          encryptedBody: encrypted.encrypt(JSON.stringify({
            message_id: messageId,
            message_text: messageText,
            session_id: sessionId,
          }))
        })
      });
  
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
  
      const contentResponse = await response.json();
      let decryptedContent = encrypted.decrypt(contentResponse.encryptedBody);
  
      // ✅ Clean base64
      const cleanBase64 = getCleanBase64(decryptedContent);
  
      if (!cleanBase64) {
        throw new Error("Decrypted content is not valid base64");
      }
  
      // ✅ Convert base64 to Blob
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "audio/wav" });
  
      // ✅ Return Blob URL
      const url = URL.createObjectURL(blob);
      return url;
  
    } catch (err) {
      console.error("❌ Error fetching audio:", err);
      return null;
    }
  };
  
  // Clean base64 helper
  const getCleanBase64 = (str) => {
    try {
      if (typeof str !== "string") return null;
      if (str.startsWith('"') && str.endsWith('"')) str = str.slice(1, -1);
      if (str.startsWith("data:audio/wav;base64,")) str = str.split(",")[1];
      return str.trim();
    } catch (e) {
      return null;
    }
  };  
  
  const handlePlayAudio = async (pair) => {
    // If user clicked the same button again, stop audio
    if (audioRef.current && currentAudioId === pair?.id) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
      setCurrentAudioId(null);
      return;
    }
  
    // Stop previous audio if another is playing
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  
    // Fetch and play new audio
    const url = await fetchAudio({
      messageId: pair?.id,
      sessionId,
      token,
      messageText: pair?.content,
    });
  
    if (url) {
      const audio = new Audio(url);
      audioRef.current = audio;
      setCurrentAudioId(pair?.id);
  
      audio.play();
  
      // ✅ Clear icon and state after audio finishes
      audio.onended = () => {
        setCurrentAudioId(null);
        audioRef.current = null;
      };
    }
  };
  
  

  return (
    <>
      <ToastContainer
        closeButton={true}
        autoClose={1000}
        position="top-right"
      />
      <div className="chat-container">
        <div
          style={{
            height: "100%",
            backgroundColor: "#F9F9F9",
            overflowY: "hiden",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            gridTemplateRows: "9% 91%",
          }}
        >
          <Header
            selectedModel={selectedModel}
            model={model}
            oncl
            isOpen={isOpen}
            isUserMenuOpen={isUserMenuOpen}
            fullname={fullname}
            handleToggle={handleToggle}
            handleModelChange={handleModelChange}
            handleFaqNavigation={handleFaqNavigation}
            handleOpenForm={handleOpenForm}
            setIsUserMenuOpen={setIsUserMenuOpen}
            dropdownRef={dropdownRef}
          />
          <div
            style={{
              height: "100%",
              backgroundColor: "#FFF",
            }}
          >
            <div className="sidebar-chat-container">
              {/* <Sidebar {...(isUpdateThread === true && { isUpdateThread: true })} /> */}
              {!isMobile && (
              <Sidebar {...sidebarProps} />
              )}
              <div
                className="chat-header-container"
                style={{
                  display: "grid",
                  gridTemplateRows:
                    roles[activeTab - 1]?.name?.length > 0
                      ? "7% 82% 11%"
                      : "88% 12%",
                }}
              >
                {roles[activeTab - 1]?.name?.length > 0 && (
                  <div className="chat-end-section">
                    <span>
                      You’re chatting with: {roles[activeTab - 1]?.name || ""}
                    </span>
                    <button
                      onClick={() => setShowChatModal(true)}
                      className="chat-end-button"
                    >
                      End Chat
                    </button>
                  </div>
                )}
                <div className="chat-box" ref={chatContainerRef}>
                  {roles[activeTab - 1]?.name?.length > 0 && (
                    <div className="message-container bot-message">
                      <div>
                        <img src={botIcon} alt="" />
                      </div>
                      <div className="message-content">
                        <div style={{ margin: "0px" }}>
                          <span>{selectedRoleDetails?.text}</span>
                        </div>
                      </div>
                    </div>
                  )}
                  {uiConversation.length === 0 &&
                  !(roles[activeTab - 1]?.name?.length > 0) ? (
                    <div className="chat-container-dashboard">
                      <div className="dashboard-profile-container"></div>
                      <div>
                        <h2 className="how-title">How can I help you?</h2>
                        <div className="card-container">
                         <Tooltip>
                            <div className="card-item">
                              {isMobile ? (
                                <div className="card-icon-title-wrapper">
                                  <span className="card-icon">
                                    <img style={{ width: "25px", height: "25px" }} src={fileDoc} alt="" />
                                  </span>
                                  <span className="card-title">Summarise Documents</span>
                                </div>
                              ) : (
                                <>
                                  <span>
                                    <img style={{ width: "25px", height: "25px" }} src={fileDoc} alt="" />
                                  </span>
                                  <span>Summarise Documents</span>
                                </>
                              )}
                              <span className="card-item-sub-text">
                                Get your documents summarised instantly
                              </span>
                            </div>
                          </Tooltip>
                          <Tooltip>
                            <div className="card-item">
                            {isMobile ? (
                                <div className="card-icon-title-wrapper">
                                  <span className="card-icon">
                                    <img style={{ width: "25px", height: "25px" }} src={help} alt="" />
                                  </span>
                                  <span className="card-title">Excel to Insights</span>
                                </div>
                              ) : (
                                <>
                                  <span>
                                    <img style={{ width: "25px", height: "25px" }} src={help} alt="" />
                                  </span>
                                  <span>Excel to Insights</span>
                                </>
                              )}
                              <span className="card-item-sub-text">
                                Upload excel docs and get insights
                              </span>
                            </div>
                          </Tooltip>
                          <Tooltip>
                            <div className="card-item">
                              {isMobile ? (
                                <div className="card-icon-title-wrapper">
                                  <span className="card-icon">
                                    <img style={{ width: "25px", height: "25px" }} src={compareDoc} alt="" />
                                  </span>
                                  <span className="card-title">Chat with Docs</span>
                                </div>
                              ) : (
                                <>
                                  <span>
                                    <img style={{ width: "25px", height: "25px" }} src={compareDoc} alt="" />
                                  </span>
                                  <span>Chat with Docs</span>
                                </>
                              )}
                              <span className="card-item-sub-text">
                                Ask questions with the documents
                              </span>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {uiConversation.map((pair, index) => (
                        <span key={index}>
                          {pair.role === "user" && (
                            <div
                              className="message-container user-message"
                              style={{ marginBottom: "15px" }}
                            >
                            {(isMobile &&
                              <div className="mobile-profile-icon">
                                <div className="first-Character">{fullname?.charAt(0)}</div>
                              </div>
                            )}
                            <div className="edit-main-section">
                              <div className="edit-container">
                                {editingId !== index && (
                                  <div
                                    className="edit-icon-container"
                                    onClick={() =>
                                      handleEditClick(index, pair.role,pair.id)
                                    }
                                  >
                                    <img
                                      width="85%"
                                      height="auto"
                                      src={editIcon}
                                      alt="edit"
                                    />
                                  </div>
                                )}
                              </div>
                              <div
                                className={
                                  editingId === index
                                    ? "message-content-editing"
                                    : "message-content"
                                }
                              >
                                {editingId === index ? (
                                  <>
                                    <textarea
                                      className="message-editor"
                                      value={editedText}
                                      onChange={(e) =>
                                        setEditedText(e.target.value)
                                      }
                                      maxLength={5000}
                                      // onKeyDown={(e) => {
                                      // InputSpecialPrevent(e);
                                      // }}
                                      rows={3}
                                    />
                                    <div className="edit-buttons-container">
                                      <button
                                        className="continue-btn"
                                        onClick={() => handleSave(index,pair)}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="end-btn"
                                        onClick={() => {
                                          setEditingId(null);
                                          setEditedText("");
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <div>
                                    {/* {pair.content} */}
                                    <MathJaxContext
                                      version={3}
                                      config={{
                                        loader: { load: ["[tex]/ams"] },
                                        tex: {
                                          packages: { "[+]": ["ams"] },
                                          inlineMath: [
                                            ["\\(", "\\)"],
                                            ["$", "$"],
                                          ],
                                          displayMath: [
                                            ["\\[", "\\]"],
                                            ["$$", "$$"],
                                          ],
                                        },
                                      }}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: getSanitizedHTML(
                                            pair.content
                                          ),
                                        }}
                                      />
                                    </MathJaxContext>
                                  </div>
                                )}
                              </div>
                              {(!isMobile &&
                              <div className="profile-icon-alignment">
                                <div className="first-Character">
                                  {fullname?.charAt(0)}
                                </div>
                              </div>
                              )}
                            </div>                    
                          </div>
                          )}

                          {/* Bot Message */}
                          {pair.role === "assistant" && (
                          <>  <div
                              className={`message-container bot-message ${
                                pair?.content === "Loading..." && "loaded"
                              }`}
                            >
                              <div>
                                <img src={botIcon} alt="bot icon" />
                              </div>
                              <div
                                style={{
                                  background: "none",
                                  boxShadow: "none",
                                  padding: "0px 10px 10px 10px",
                                }}
                                className="message-content"
                              >
                                <MathJaxContext
                                  version={3}
                                  config={{
                                    loader: { load: ["[tex]/ams"] },
                                    tex: {
                                      packages: { "[+]": ["ams"] },
                                      inlineMath: [
                                        ["\\(", "\\)"],
                                        ["$", "$"],
                                      ],
                                      displayMath: [
                                        ["\\[", "\\]"],
                                        ["$$", "$$"],
                                      ],
                                    },
                                  }}
                                >
                                  <div
                                    ref={(el) =>
                                      (assistantRefs.current[index] = el)
                                    }
                                    dangerouslySetInnerHTML={{
                                      __html: getSanitizedHTML(pair.content),
                                    }}
                                  />
                                </MathJaxContext>
                                {/* {selectedModel === "DALL-E 3" && (loading===true||pair?.image_data) && (
                                  <div>
                                    <img
                                      src={pair?.image_data?.image_url || loadingImage}
                                      alt="Generated Image"
                                    />
                                  </div>
                                )} */}


                                {/* Feedback Buttons */}
                                {pair?.content !== "Loading..." &&
                                pair.role === "assistant" ? (
                                  <>
                                    {(!isLoading ||
                                      uiConversation.length - 1 !== index) && (
                                      <div className="feedback-buttons">
                                        <button
                                          className={`like-button ${
                                            pair.feedback=='like'
                                              ? "disabled"
                                              : ""
                                          }`}
                                          disabled={
                                            pair.feedback=='like'?true:false
                                          }
                                          onClick={() =>
                                            handleFeedback(index, "like", pair)
                                          }
                                        >
                                          <img
                                            src={
                                              pair.feedback=='like'
                                                ? likeSelected
                                                : like
                                            }
                                            className="like-dislike-img"
                                            alt="like-image"
                                          />
                                        </button>
                                        <button
                                          className={`dislike-button ${
                                            pair.feedback=='dislike'
                                              ? "disabled"
                                              : ""
                                          }`}
                                          disabled={
                                            pair.feedback=='dislike'?true:false
                                          }
                                          onClick={() =>
                                            handleFeedback(
                                              index,
                                              "dislike",
                                              pair
                                            )
                                          }
                                        >
                                          <img
                                            src={
                                              pair.feedback=="dislike"
                                                ? dislikeSelected
                                                : dislike
                                            }
                                            className="like-dislike-img"
                                            alt="dislike-image"
                                          />
                                        </button>
                                        <button
                                          className="dislike-button"
                                          disabled={copied}
                                          onClick={() => {
                                            handleCopyClick(index);
                                          }}
                                        >
                                          <img
                                            src={
                                              copied ? copyActive : copyInactive
                                            }
                                            className="like-dislike-img"
                                            alt="copy icon"
                                          />
                                        </button>
                                        <button
                                          className="dislike-button"
                                          disabled={copied}
                                          onClick={()=>handlePlayAudio(pair)}
                                        >
                                          <img
                                              src={
                                               currentAudioId === pair?.id ?speakerFilledIcon:speakerIcon
                                              }
                                              className="like-dislike-img"
                                              alt="Audio icon"
                                            />

                                        </button>
                                        {/* Feedback Input */}
                                        {showFeedbackInput &&
                                          currentFeedbackIndex === index && (
                                            <div
                                              ref={feedbackContainerRef}
                                              className="additional-feedback"
                                            >
                                              <button
                                                className="close-arrow"
                                                onClick={() =>
                                                  handleFeedbackModalClose(
                                                    index
                                                  )
                                                }
                                              >
                                                <img
                                                  src={closeIcon}
                                                  alt="arrow-icon"
                                                />
                                              </button>
                                              <div className="feedback-input-area">
                                                <textarea
                                                  ref={feedbackInputRef}
                                                  className="feedback-input"
                                                  value={
                                                    feedbackInput[index]
                                                      ?.comment || ""
                                                  }
                                                  onChange={
                                                    handleFeedbackCommentChange
                                                  }
                                                  placeholder="Your feedback"
                                                  maxLength={5000}
                                                  onKeyDown={(event) => {
                                                    handleKeyPressFeedback(
                                                      event,
                                                      "dislike",
                                                      index,
                                                      pair
                                                    );
                                                  }}
                                                  style={{ resize: "none" }}
                                                />
                                                {isTypingFeedback && (
                                                  <div className="apply-feedback">
                                                    Press Enter to Submit
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        {/* Prompt Suggestions */}
                                        {pair?.content !== "Loading..." &&
                                        pair?.role === "assistant" &&
                                        uiConversation?.length - 1 === index ? (
                                          <div style={{ marginBottom: "5%" }}>
                                            {suggestions?.length>0&&<div className="suggestion-title">
                                              {"Explore further"}
                                            </div>}
                                            <div className="suggestions-wrapper">
                                              {suggestions?.map(
                                                (res, index) => (
                                                  <span
                                                    key={index}
                                                    onClick={() =>
                                                      handleSearchSuggestion(
                                                        res
                                                      )
                                                    }
                                                    className="suggestion-chip"
                                                  >
                                                    <span>{res}</span>
                                                    <span className="icon">
                                                      <img
                                                        src={insertArrow}
                                                        alt="arrow"
                                                      />
                                                    </span>
                                                  </span>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <div />
                                        )}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div className="feedback-buttons" />
                                )}
                              </div>
                            </div>
                             
                            </>
                          )}
                        </span>
                      ))}
                    </>
                  )}
                  <div ref={chatEndRef}></div>    
                </div>

                <div className="input-footer">
                    <div className="footer-info">
                    <div className="card-role-container">
                      {!activeTab &&
                        roles.map((role) => (
                          <Tooltip id={"1"} text={role.title} key={role.id}>
                            <div
                              key={role.id}
                              className={`card-items-role ${
                                activeTab === role.id ? "active" : ""
                              }`}             
                              onClick={async() => {
                                if (activeTab !== role.id) {
                                  addMessagesFunction(role?.name, role?.text);
                                }          
                                setActiveTab(
                                  activeTab === role?.id ? null : role?.id
                                );
                                await stopStreaming();
                                await clearChatData();
                              }}                             
                              onMouseEnter={() => setHoveredId(role.id)}
                              onMouseLeave={() => setHoveredId(null)}
                            >
                              <img
                                src={
                                  hoveredId === role.id
                                    ? role.activeIcon
                                    : role.icon
                                } // Change only hovered image
                                alt={role.name}
                              />
                              {role.name}
                            </div>
                          </Tooltip>
                        ))}
                  
                    </div>
                    {!isMobile && (
                    <div className="note-section">
                      <div className="heading-info">
                        <span className="text">Enter = Search and Shift+Enter = New Line</span>
                      </div>
                    </div>
                    )}
                  </div>       
                    <div className="input-container">
                  <>
                  {/* {(!isMobile &&
                  <label className="file-upload-icon">
                        <input
                          type="file"
                          multiple
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <img src={uploadIcon} alt="upload-icon" />
                      </label>
                  )} */}
                      <textarea
                        ref={textareaRef}
                        className={`input-box ${
                          isLoading && !message.trim() ? "disabled" : ""
                        }`}
                        value={message}
                        onChange={handleInputChange}
                       onKeyDown={(e) => {
                        if (!isLoading) {
                          if (e.key === "Enter") {
                            if (isMobile || e.shiftKey) {

                              setTimeout(() => {
                                if (textareaRef.current) {
                                  textareaRef.current.style.height = "auto";
                                  textareaRef.current.style.height =
                                    textareaRef.current.scrollHeight + "px";
                                }
                              }, 0);
                              return;
                            } else {
                              e.preventDefault();
                              handleKeyPress(e);
                            }
                          } else {
                            handleKeyPress(e);
                          }
                        }
                      }}
                        maxLength={20000}
                        placeholder="Ask me anything..."
                        autoComplete="off"
                        style={{
                          resize: "none",
                          overflowY: "auto",
                          lineHeight: "24px",
                          height: "72px",
                          paddingLeft:'1%',
                        }}
                        // disabled={isLoading}
                        rows={1}
                      />
                  </>  
                      <button
                        className={`output-arrow ${
                          isLoading || !message.trim() ? "disabled" : ""
                        }`}
                        onClick={handleSendMessage}
                        disabled={isLoading || !message.trim()}
                      >
                        <img src={outputArrow} alt="arrow-icon" />
                      </button>
                    </div>
                    <div className="content-info">
                      AI-generated content may be incorrect
                    </div>
                  </div>
              </div>
            </div>
          </div>                                                        
        </div>

        {/* End Chat Modal */}
        <ConfirmModal
          show={showChatModal}
          role_name={roles[activeTab - 1]?.name || ""}
          title="End chat"
          message={`You are about to end your conversation with ${
            roles[activeTab - 1]?.name || ""
          }!`}
          primaryBtnText="End"
          secondaryBtnText="Continue"
          onPrimaryClick={() => {
            clearChatData();
            setActiveTab(null);
            emit("resetSelectedThread");
            stopStreaming();
               
          }}
          onSecondaryClick={handleContinue}
        />

        {/* New Chat Session Modal */}
        <ConfirmModal
          show={showNewChat}
          title="New Chat"
          message="Starting a new chat. Are you sure you want to continue?"
          primaryBtnText="Cancel"
          secondaryBtnText="Continue"
          onPrimaryClick={handleNewSessionCancel}
          onSecondaryClick={handleNewSessionContinue}
        />
      </div>
    </>
  );
}

export default Chat;
export const ConfirmModal = ({
  show,
  title,
  message,
  primaryBtnText,
  secondaryBtnText,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  if (!show) return null;

  return (
    <Modal>
        <div className="end-chat-title">{title}</div>
        <div className="chat-text">{message}</div>
        <div className="chat-modal-buttons">
          <button onClick={onPrimaryClick} className="end-btn">
            {primaryBtnText}
          </button>
          <button onClick={onSecondaryClick} className="continue-btn">
            {secondaryBtnText}
          </button>
        </div>
    </Modal>
  );
};
